import React from 'react';

import block from 'propmods';

import { MerchantInfo } from '../../../model/billing';
import CopyField from '../../CopyField/CopyField';
import { Header } from '../../Form/Form';
import { merchantsTableCaption } from '../descriptions';

import './MerchantsTable.scss';

const b = block('MerchantsTable');

interface StatusProps {
    enabled?: boolean;
}

const MerchantStatus: React.FC<StatusProps> = ({ enabled }) => {
    return <div {...b('status', { enabled })}>{enabled ? 'Подтвержден' : 'Подтверждается'}</div>;
};

interface RowProps {
    merchant: MerchantInfo;
}

const emptyCellContent = '–';

const MerchantRow: React.FC<RowProps> = ({ merchant }) => {
    return (
        <tr {...b('row')}>
            <td {...b('name-cell')}>{merchant.organization_name}</td>
            <td {...b('token-cell')}>
                {merchant.token ? <CopyField text={merchant.token} label="" border={false} /> : emptyCellContent}
            </td>
            <td {...b('description-cell')}>{merchant.description || emptyCellContent}</td>
            <td {...b('status-cell')}>
                <MerchantStatus enabled={merchant.enabled} />
            </td>
        </tr>
    );
};

interface ListProps {
    merchants: MerchantInfo[];
}

const MerchantsTable: React.FC<ListProps> = ({ merchants }) => {
    return (
        <div {...b()}>
            <Header caption={merchantsTableCaption}>Продавцы</Header>
            {merchants.length !== 0 ? (
                <table {...b('table')}>
                    <thead>
                        <tr>
                            <th>Название</th>
                            <th>Токен</th>
                            <th>Описание</th>
                            <th>Статус</th>
                        </tr>
                    </thead>
                    <tbody>
                        {merchants.map((merchant) => (
                            <MerchantRow merchant={merchant} key={merchant.entity_id} />
                        ))}
                    </tbody>
                </table>
            ) : (
                <div {...b('stub')}>Вы еще никого не добавили</div>
            )}
        </div>
    );
};

export default MerchantsTable;
